import { cn } from "@/lib/utils";
import React from "react";

export function Card({ className, children, ...props }) {
  return (
    <div
      className={cn(
        "bg-white rounded-lg shadow-lg border border-bambu-green-pastel p-6",
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}

export function CardHeader({ className, children, ...props }) {
  return (
    <div className={cn("flex flex-col space-y-1.5 mb-4", className)} {...props}>
      {children}
    </div>
  );
}

export function CardTitle({ className, children, ...props }) {
  return (
    <h3
      className={cn(
        "text-2xl font-bold leading-none tracking-tight text-bambu-black font-montserrat",
        className
      )}
      {...props}
    >
      {children}
    </h3>
  );
}

export function CardContent({ className, children, ...props }) {
  return (
    <div className={cn("pt-0", className)} {...props}>
      {children}
    </div>
  );
}
